<template>
    <div v-if="itemsLength > 0 && item">
        <div
            ref="marqueeContainer"
            class="marquee py-2 text-center d-print-none marquee-container d-flex flex-wrap justify-content-center align-items-center"
            :class="`bg-${item.theme}`"
            :style="hasTrustpilot ? 'min-height: 40px' : ''"
        >
            <div :class="[item.class, item.modif]" v-html="useExternalAmounts(item.text)" />
            <NuxtLink
                v-if="item.link"
                :to="item.link.to"
                class="decorated ms-2 contact-us-link"
            >
                {{ item.link.text }}
            </NuxtLink>
        </div>
        <div
            ref="measurer"
            style="visibility: hidden; position: absolute; top: 0; left: 0; width: 100%;"
        >
            <div
                v-for="it in items"
                :key="it.text"
                class="marquee py-2 text-center d-print-none marquee-container d-flex flex-wrap justify-content-center align-items-center"
                :class="`bg-${it.theme}`"
            >
                <div :class="[it.class, it.modif]" v-html="useExternalAmounts(it.text)" />
                <NuxtLink
                    v-if="it.link"
                    :to="it.link.to"
                    class="decorated ms-2 contact-us-link"
                >
                    {{ it.link.text }}
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useExternalLinks } from '~/composables/useExternalLinks'
import { useExternalAmounts } from '~/composables/useExternalAmounts'
import { useSettingsStore } from '~/stores/SettingsStore'

const settingsStore = useSettingsStore()
const items = computed(() => settingsStore.translatable('marquee_items'))
const itemsLength = items.value.length
const currentIndex = ref(0)
const timeoutId = ref(null)
const item = computed(() => items.value[currentIndex.value])
const marqueeContainer = ref(null)
const measurer = ref(null)
const originalMax = ref(0)
const hasTrustpilot = computed(() => items.value.some(it => it.modif === 'trustpilot'))

useExternalLinks('.contact-us-link')

const setOriginalHeight = async () => {
    await nextTick()
    if (!marqueeContainer.value || !measurer.value) return
    measurer.value.style.width = `${marqueeContainer.value.offsetWidth}px`
    const heights = Array.from(measurer.value.children).map(el => el.offsetHeight)
    originalMax.value = Math.max(...heights)
    if (hasTrustpilot.value) {
        originalMax.value = Math.max(originalMax.value, 40)
    }
    marqueeContainer.value.style.minHeight = `${originalMax.value}px`
}

const showNextComponent = () => {
    currentIndex.value = (currentIndex.value + 1) % itemsLength
    updateTimer()
    loadTrustpilotWidget()
}

const updateTimer = () => {
    clearTimeout(timeoutId.value)
    if (itemsLength > 1) {
        timeoutId.value = setTimeout(showNextComponent, item.value.seconds * 1000)
    }
}

const loadTrustpilotWidget = () => {
    if (item.value?.modif === 'trustpilot') {
        nextTick(() => {
            const w = document.querySelector('.trustpilot-widget')
            if (w && window.Trustpilot) {
                window.Trustpilot.loadFromElement(w, true)
            }
        })
    }
}

onMounted(async () => {
    await setOriginalHeight()
    updateTimer()
    loadTrustpilotWidget()
})

watch(item, loadTrustpilotWidget)
</script>

<style scoped>
.marquee-container p {
    margin-bottom: 0;
}
</style>
